import { Select } from "antd";
import React, { forwardRef } from "react";
import { shallowEqual, useSelector } from "react-redux";

const SelectUserDocument = ({ onUpload = false, ...props }) => {
  const { document_list, actionType } = useSelector(
    (state) => state.ethics.form.upload,
    shallowEqual
  );

  const options =
    actionType === "replace"
      ? document_list?.uploaded?.filter((d) => d.document_status === "approve")
      : onUpload
      ? document_list?.unupload
      : document_list?.uploaded;

  return (
    <Select
      showSearch
      loading={props.loading}
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      dropdownMatchSelectWidth={false}
      {...props}
    >
      {options?.map((n, i) => (
        <Select.Option
          key={i}
          value={n.code}
          style={{
            color: n.document_status === "approve" ? "#97D700" : "",
          }}
        >
          {n.name}
        </Select.Option>
      ))}
    </Select>
  );
};
export default forwardRef(SelectUserDocument);
